import { processConfig, processConfigDelete } from 'Helper/processConfig'

function lobbyDashboardConfigReducer(state = {}, action = {}) {
  let newState
  switch (action.type) {
    case 'STORE_CONFIG_READ':
    case 'STORE_CONFIG_READ_ALL':
    case 'STORE_CONFIG_SEARCH':
    case 'STORE_CONFIG_CREATE':
    case 'STORE_CONFIG_UPDATE':
      // create a new state object
      newState = { ...state }
      // if not an array, then its a single object
      if (Array.isArray(action.result)) {
        // if its an array
        // for each returned config item, set the key in the
        // state object to the new value
        action.result.map(config => {
          newState = processConfig(newState, config, [null, 'lobbyDashboard'])
        })
      } else {
        newState = processConfig(newState, action.result, [
          null,
          'lobbyDashboard'
        ])
      }
      return newState
    case 'STORE_CONFIG_DELETE':
      newState = processConfigDelete(state, action.result, [
        null,
        'lobbyDashboard'
      ])
      return newState
    default:
      return state
  }
}

export default lobbyDashboardConfigReducer
